import React from 'react';
import { connect } from 'react-redux';
import FileAcceptor from '../components/uploadFiles/FileAcceptor';

const UploadFile = (props) => {
  return <FileAcceptor {...props} />;
};

const mapStateToProps = (state, props) => {
  return {
    flows: state.flows,
  };
};

export default connect(mapStateToProps)(UploadFile);
